import { useNavigate } from "react-router-dom";

import { Modal, ModalName } from "pages/setting/components/Modal.styled";
import { ButtonList } from "pages/setting/components/Sections/components/ButtonList";
import { AdminLeaveNotice } from "pages/setting/components/Sections/NormalSetting/Modals/AdminLeaveConfirmModal/components/AdminLeaveNotice";
import { withdrawMyAdmin } from "shared/api/MemberApi";
import { alertDialog, confirmDialog } from "shared/ui/feedback";

/**
 * '관리자 권한 탈퇴' 모달 컴포넌트
 */
export const AdminLeaveConfirmModal = ({ isMoalOpen, closeModal }) => {
  const navigate = useNavigate();

  const openPermissionConfirm = async () => {
    const shouldProceed = await confirmDialog(
      "총학생회 관리 홈페이지에 대한 관리자 권한이 모두 박탈됩니다.\n정말 탈퇴하시겠습니까?",
    );

    if (!shouldProceed) return;

    try {
      // 서버가 토큰으로 본인을 식별하는 셀프 탈퇴 엔드포인트를 호출한다.
      await withdrawMyAdmin();
      // 관리자 권한이 박탈되었으므로 로그아웃 후 로그인 페이지로 이동한다.
      localStorage.removeItem("admintoken");
      localStorage.removeItem("userId");
      alertDialog("관리자 권한이 탈퇴되었습니다.");
      closeModal();
      navigate("/login", { replace: true });
    } catch (error) {
      alertDialog("권한 탈퇴에 실패했습니다. 잠시 후 다시 시도해주세요.");
    }
  };
  return (
    <Modal
      isOpen={isMoalOpen}
      onRequestClose={closeModal}
      style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
    >
      <ModalName>관리자 권한 탈퇴하기</ModalName>

      {/* 주의 문구 */}
      <AdminLeaveNotice />

      {/* 버튼 모음 */}
      <ButtonList
        closeModal={closeModal}
        openConfirm={openPermissionConfirm}
        disabled={false}
        confirmMessage="권한 탈퇴하기"
      />
    </Modal>
  );
};
